<div class="checkbox-container" (click)="onCheckedChange($event)">
  <label class="checkbox">
    <input type="checkbox" [checked]="checked" (change)="onCheckedChange($event)"/>
    <span class="checkmark"></span>
  </label>
  <span class="checkbox-text">{{ label }}</span>
</div>
